import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import ProfileRateWizardStep from './ProfileRateWizardStep';
import AboutWizardStep from './BaseAboutWizardStep';
import StepHeader from './StepHeader';
import BaseReviewWizard from './BaseReviewWizard';
import { PROFILE } from '../../constants/ReviewType';
import { ProfileReviewSteps } from '../../constants/ReviewSteps';
import defaultFetchAvatars from '../../utils/fetchAvatars';
export default function ProfileReviewWizard(_ref) {
  let {
    catalogServices,
    displayName,
    fetchAvatars = defaultFetchAvatars,
    reviewableIconUrl,
    reviewableName,
    userEmail
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["catalogServices", "displayName", "fetchAvatars", "reviewableIconUrl", "reviewableName", "userEmail"]);

  const WizardHeader = useCallback(headerProps => /*#__PURE__*/_jsx(StepHeader, Object.assign({}, headerProps, {
    reviewableName: reviewableName,
    reviewableIconUrl: reviewableIconUrl,
    reviewType: PROFILE
  })), [reviewableName, reviewableIconUrl]);
  const RateComponent = useCallback(wizardProps => {
    return /*#__PURE__*/_jsx(UIWizardStep, {
      children: /*#__PURE__*/_jsx(ProfileRateWizardStep, Object.assign({}, wizardProps, {
        catalogServices: catalogServices,
        reviewableName: reviewableName
      }))
    });
  }, [catalogServices, reviewableName]);
  const AboutComponent = useCallback(wizardProps => /*#__PURE__*/_jsx(UIWizardStep, {
    children: /*#__PURE__*/_jsx(AboutWizardStep, Object.assign({}, wizardProps, {
      displayName: displayName,
      fetchAvatars: fetchAvatars,
      userEmail: userEmail
    }))
  }), [displayName, fetchAvatars, userEmail]);
  const stepComponents = useMemo(() => [RateComponent, AboutComponent], [RateComponent, AboutComponent]);
  const reviewSteps = useMemo(() => Object.values(ProfileReviewSteps), []);
  return /*#__PURE__*/_jsx(BaseReviewWizard, Object.assign({}, rest, {
    HeaderComponent: WizardHeader,
    StepComponents: stepComponents,
    reviewSteps: reviewSteps,
    reviewType: PROFILE
  }));
}